import * as React from "react";
import {
  Create,
  TextInput,
  BooleanInput,
  ReferenceInput,
  PasswordInput,
  usePermissions,
} from "react-admin";
import {
  validateEmail,
  validatePhone,
  validateRequired,
} from "../utils/Validations";
import { SimpleForm } from "../common/SimpleForm";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";
import { AutocompleteInputDefaultValue } from "../common/AutocompleteInputDefaultValue";

const UserCreate = () => {
  const { permissions } = usePermissions();

  return (
    <Create title="Crear Usuario" mutationMode="pessimistic" redirect="list">
      <SimpleForm>
        <TextInput
          source="firstName"
          label="Nombre"
          validate={validateRequired}
        />
        <TextInput
          source="lastName"
          label="Apellido"
          validate={validateRequired}
        />
        <TextInput source="email" label="Email" validate={validateEmail} />
        <PasswordInput
          source="password"
          label="Contraseña"
          validate={validateRequired}
        />
        <TextInput
          source="phone"
          label="Teléfono"
          helperText="Ej: +5491123456789"
          validate={validatePhone}
        />
        <ReferenceInput
          source="restaurant"
          reference="restaurants"
          perPage={100}
          filter={{
            active: true,
            type: RESTAURANT_TYPES.REGULAR,
          }}
        >
          <AutocompleteInputDefaultValue
            permissions={permissions}
            optionText="name"
            validate={validateRequired}
            filterToQuery={(searchText) => ({ name: searchText })}
            label="Restaurante"
          />
        </ReferenceInput>
        <BooleanInput source="active" label="Activo" defaultValue={true} />
      </SimpleForm>
    </Create>
  );
};

export default UserCreate;
